export default [
  {
    path: '/apps/grupo-estoque/list',
    name: 'apps-grupo-estoque-list',
    component: () => import('@/views/cadastros-gerais//grupo-estoque/list/Index.vue'),
    meta: {
      pageTitle: 'Grupo Estoque',
      resource: 'AdminHanes',
    },
  },
  // {
  //     path: '/apps/grupo-estoque/edit/:id',
  //     name: 'apps-grupo-estoque-edit',
  //     component: () => import('@/views/cadastros-gerais/grupo-estoque/grupo-estoque-edit/GrupoEstoqueEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Grupo Estoque',
  //         resource: 'AdminHanes',
  //     },
  // },
];
